import React, { useState } from 'react';
import { Menu, X } from 'lucide-react';

const Header = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  const navigationLinks = [
    { name: 'Home', href: '#home' },
    { name: 'About', href: '#about' },
    { name: 'Services', href: '#services' },
    { name: 'Sectors', href: '#sectors' },
    { name: 'Partners', href: '#partners' },
    { name: 'Team', href: '#team' },
    { name: 'Contact', href: '#contact' }
  ];

  return (
    <header className="dark-header">
      <div className="flex items-center">
        <img 
          src="/nfit-logo-clean.png" 
          alt="NFIT Corp Logo" 
          className="h-12 w-auto object-contain"
          style={{ filter: 'brightness(1.2)' }}
        />
      </div>

      {/* Desktop Navigation */}
      <nav className="dark-nav hidden md:flex">
        {navigationLinks.map((link) => (
          <a
            key={link.name}
            href={link.href}
            className="dark-nav-link"
          >
            {link.name}
          </a>
        ))}
      </nav>

      {/* CTA Button */}
      <div className="hidden md:block">
        <a href="#contact" className="btn-primary">
          Get Started
        </a>
      </div>

      {/* Mobile Menu Button */}
      <button
        className="md:hidden p-2"
        onClick={() => setIsMenuOpen(!isMenuOpen)}
        style={{ color: '#00FFD1' }}
      >
        {isMenuOpen ? <X size={24} /> : <Menu size={24} />}
      </button>

      {/* Mobile Navigation */}
      {isMenuOpen && (
        <div className="absolute top-full left-0 w-full bg-black border-t border-gray-800 md:hidden">
          <nav className="flex flex-col p-4 space-y-4">
            {navigationLinks.map((link) => (
              <a
                key={link.name}
                href={link.href}
                className="dark-nav-link"
                onClick={() => setIsMenuOpen(false)}
              >
                {link.name}
              </a>
            ))}
            <a href="#contact" className="btn-primary mt-4">
              Get Started
            </a>
          </nav>
        </div>
      )}
    </header>
  );
};

export default Header;